import { APP_BASE_HREF } from '@angular/common';
import { ApplicationConfig, NgZone, importProvidersFrom, provideAppInitializer, provideEnvironmentInitializer } from '@angular/core';
import { provideClientHydration, withEventReplay, withNoHttpTransferCache } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { provideLoaders } from '@frontend/loaders';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { provideCoralSportsFeatures } from '@frontend/oxygen/cm-host-app';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { provideLazySportsHttpInterceptors, provideSportsWebRootServices } from '@frontend/sports/web/platform-lib/providers';
import { provideVanillaCore } from '@frontend/vanilla/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { providePaymentsFeatures } from '../../payments/cashier-app/src/app/payments.feature';
import { appRoutes } from './app.routes';
import { extProviders } from './environments/environment';
import { provideHostRouter } from './host-router';
import { provideHostApp } from './provide';

export const appConfig: ApplicationConfig = {
    providers: [
        provideEnvironmentInitializer(() => console.log('[AppConfig]: Start running EnvironmentInitializer')),
        provideAppInitializer(() => console.log('[AppConfig]: Start running AppInitializer')),
        { provide: APP_BASE_HREF, useValue: '/' },
        {
            provide: NgZone,
            useValue: new NgZone({ shouldCoalesceEventChangeDetection: true }),
        },
        provideClientHydration(withEventReplay(), withNoHttpTransferCache()),
        provideHostRouter(appRoutes),
        provideAnimationsAsync(),
        importProvidersFrom(
            StoreModule.forRoot(
                {},
                {
                    runtimeChecks: {
                        strictStateImmutability: false,
                        strictActionImmutability: false,
                        strictStateSerializability: false,
                        strictActionSerializability: false,
                    },
                },
            ),
            EffectsModule.forRoot([]),
        ),
        provideVanillaCore(provideLazySportsHttpInterceptors()),
        provideLoaders(),
        provideHostApp(),
        provideSportsWebRootServices(),
        extProviders,
        //TODO: payments to remove TranslateModule
        providePaymentsFeatures(),
        provideCoralSportsFeatures(),
        provideEnvironmentInitializer(() => console.log('[AppConfig]: End running EnvironmentInitializer')),
        provideAppInitializer(() => console.log('[AppConfig]: End running AppInitializer')),
    ],
};
